import Grid2 from '@mui/material/Grid2';
import MultiColPointDataTable from '@src/components/_shared/MultiColPointDataTable';
import { Typography } from '@mui/material';
import useGetInternalWidgetConfig from '@src/hooks/api/queries/useGetInternalWidgetConfig';
import { WidgetTypePointList } from '@src/types/Widget';
import Spinner from '@components/_elements/Spinner/Spinner';
import QueryKeys from '@src/constants/queryKeys';
import FormattedAlias from '../Translations/FormattedAlias';

export default function MasterTrackerDetail() {
  const {
    data: widgetConfig,
    isLoading,
    isError,
  } = useGetInternalWidgetConfig<WidgetTypePointList>(
    `masterTrackerDetail`,
    {
      sourceDeviceId: 'master_tracker_1',
    },
    {
      queryKeys: [QueryKeys.masterTracker, 'master_tracker_1'],
    },
  );

  if (isLoading) {
    return <Spinner type='content-small' />;
  }
  if (isError) {
    return (
      <Typography textAlign='center' marginTop='50px'>
        <FormattedAlias id={'Error fetching master tracker details'} />
      </Typography>
    );
  }

  return (
    <Grid2 container justifyContent='space-evenly'>
      <MultiColPointDataTable
        dataPointsMatrix={widgetConfig?.dataPoints || []}
      />
    </Grid2>
  );
}
